export type TimestampLike = {
  toDate: () => Date;
};

export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

export function isTimestampLike(value: unknown): value is TimestampLike {
  return isRecord(value) && typeof value.toDate === 'function';
}

export function optionalString(value: unknown): string | undefined {
  return typeof value === 'string' && value.trim() ? value.trim() : undefined;
}

export function readString(value: unknown, fallback = ''): string {
  return typeof value === 'string' ? value : fallback;
}

export function readNumber(value: unknown, fallback = 0): number {
  return typeof value === 'number' && Number.isFinite(value) ? value : fallback;
}

export function readArray<T>(
  value: unknown,
  isItem: (value: unknown) => value is T,
): T[] {
  return Array.isArray(value) ? value.filter(isItem) : [];
}

export function timestampDate(value: unknown): Date | null {
  if (!isTimestampLike(value)) {
    return null;
  }

  try {
    const date = value.toDate();
    return date instanceof Date && Number.isFinite(date.getTime()) ? date : null;
  } catch {
    return null;
  }
}

export function timestampIso(value: unknown): string | null {
  return timestampDate(value)?.toISOString() ?? null;
}
